import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import {StyledConfigurationContainer, StyledIndexContainerDiv, StyledLeadContainer} from '../../Components/Styled/index';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import history from '../../Utility/history';
import { privateRoutesPath } from '../../Routes';
import { GridRowModes } from '@mui/x-data-grid';
import moment from 'moment';
import {useSnackbar} from 'notistack';
import DataGridTable from '../../Components/DataGrid';
import SearchProduct from './SearchProduct';
import LeadDialog from '../../Components/LeadDialog';
import { requestDeleteApiCall, updateRequestData } from '../../Utility/apiHelper';
import { useDispatch, useSelector } from 'react-redux';
import { handleValidateCodevalue, nameWidth, productIdWidth, productNameWidth, productTypeWidth, searchEntity, statusWidth, vendorNameWidth, whocolumnWidth } from '../../Utility/constant';
import { requestGetAllMerchant } from '../../Store/Merchant/action';
import BiztantuSearch from '../../Components/BiztantuSearch';
import { requestGetAllProducts } from '../../Store/Product/action';
import BiztantuLoader from '../../Components/Loader';
import { resetState } from '../../Utility/resetSearchFunction';
import { requestHideLoader, requestShowLoader } from '../../Store/Global/action';
import { resetSearch, setSearch } from '../../Store/SearchReducer/action';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { useEntitySearch } from '../../Utility/hooks/useEntitySearch';
import useNavigation from '../../Utility/hooks/useNavigation';
import './product.css';

const ProductPage = ({}) => {
    const [dataGridData, setDatagridData] = useState([]);
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [rowModesModel, setRowModesModel] = React.useState({});
    const [selectionModel, setSelectionModel] = React.useState([]);
    const [isDeleteProductDialog, setDeleteProductDialog] = useState(false);
    const token = localStorage.getItem('accessToken');
    const dispatch = useDispatch();
    useEffect(()=>{
    dispatch(requestGetAllMerchant(token));
    },[])
    const merchantData = useSelector(state => state?.merchant?.merchant);
    const specificRolePermission = useSelector(state => state?.owner?.rolebasedData);
    const internationalise = useSelector(state => state?.internationalise?.currentHashMapData);
    const currentUser = useSelector(state => state?.owner?.currentuser);
    const productData = useSelector(state => state?.product?.product);
    const productSearch = useSelector((state) => (state.search.product));
    
    const { navigateTo } = useNavigation();
    const handleChangeSearchField = (event) => {
        dispatch(setSearch(searchEntity?.product, {
          ...productSearch,
          [event.target.name]: event.target.value,
        }));
    }

    const ownerlist = useSelector(state => state?.owner?.ownerlist);  
    const [ownerlistdropdown, setownerlistdropdown] = useState([]);
      const preserveSearch = useSelector(
        state => state?.search?.preserveSearch?.[searchEntity?.product]
      );

      useEntitySearch({
          entity: searchEntity?.product,
          searchState: productSearch,
          preserveSearch,
          isReady : true,
          fetchAction: (params) =>
              requestGetAllProducts({
                  params,
              }),
      });
    useEffect(() => {
      const ownerlistdata = ownerlist.map(item => {
          return {
            name: `${item?.firstName} ${item?.lastName}`,
            id: item?.id
          }
      })
        
          setownerlistdropdown(ownerlistdata);
      },[ownerlist])
      
          useEffect(() => {
                  dispatch(requestGetAllMerchant());     
              return ()=>{
                setDatagridData([])
              }
               }, [currentUser]);
      
               
          useEffect(() => {
          const updatedLeadTable = (productData ||[]).map((item,index)=>{
                              return {
                                  ...item,
                              }
                          })
                          setDatagridData(updatedLeadTable);
               }, [productData]);

          
          
    // when you handleReset button
    const handleResetSearch = () => {
          dispatch(
              resetSearch(searchEntity?.product,resetState(productSearch)
            )
          );
        };
    const columns = [
      { 
        field: 'id', 
        headerName: handleValidateCodevalue(internationalise,'PROD_SEARCH_PRODUCT_ID'),
        flex: 1,
        minWidth : productIdWidth,
        editable: false ,
        renderCell : ({id})=>(
        <span
        onClick={handleEditProduct(id,true)}
        className="product-id-link"
        >
            {id}
          </span>
        )
      },
        { 
          field: 'name', 
          headerName: handleValidateCodevalue(internationalise,'PROD_SEARCH_PRODUCT_NAME'),
          flex: 1,
          editable: true ,
          minWidth: productNameWidth,
        },
        {
            field: 'sellingPrice',
            headerName: handleValidateCodevalue(internationalise,'PROD_SEARCH_SP'),
            flex: 1,
            editable: true,
            minWidth: nameWidth,
        },
        {
            field: 'type',
            headerName: handleValidateCodevalue(internationalise,'PRODUCT_TYPE'),
            flex: 1,
            editable: false,
            minWidth: productTypeWidth,
            valueGetter:({value})=>{
              if(value == null){
                return ""
              }  
              else{
               return handleValidateCodevalue(internationalise,value)
              }
              }
            
        },
        {
          field: 'status',
          headerName: handleValidateCodevalue(internationalise,'PRODUCT_STATUS'),
          flex: 1,
          minWidth: statusWidth,
          editable: false,
          valueGetter:({value})=>{
            if(value == null){
              return ""
            }  
            else{
             return handleValidateCodevalue(internationalise,value)
            }
            }
        },
        ...(specificRolePermission?.isVendorView) ?
        [{ 
          field: 'vendorId', 
          headerName: handleValidateCodevalue(internationalise,'PROD_SEARCH_VENDOR'),
          flex: 1,
          minWidth: vendorNameWidth,
          editable: false ,
          valueGetter:({value})=>{
            const merchant = (merchantData || []).find( merchant => merchant.id ==value)
           return merchant? merchant?.name : ""
          }
        }] : 
        [],
        {
          field: 'createdAt',
          headerName: handleValidateCodevalue(internationalise,'COMMON_CREATED_AT'),
          type: 'date',
          flex: 1,
          minWidth : whocolumnWidth,
          editable: false,
          valueGetter: ({ value }) => value && moment(value).format('MM/DD/YYYY'),
        },
        {
          field: 'updatedAt',
          type: 'date',
          headerName: handleValidateCodevalue(internationalise,'COMMON_UPDATED_AT'),
          flex: 1,
          minWidth : whocolumnWidth,
          editable: false,
          valueGetter: ({ value }) => value && moment(value).format('MM/DD/YYYY'),
        },
      ];

    const handleEditClick = (id) => () => {
        setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
      };
    
      const handleSaveClick = (id) => () => {
        setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View } });
      };
    
      const handleEditProduct = (id,value) => () => {
      navigateTo(`${privateRoutesPath.EDIT_PRODUCT}/${id}`,{ isViewMode : value },searchEntity?.product);
      };
    
      const handleCancelClick = (id) => () => {
        setRowModesModel({
          ...rowModesModel,
          [id]: { mode: GridRowModes.View, ignoreModifications: true },
        });
    
        const editedRow = dataGridData.find((row) => row.id === id);
        if (editedRow.isNew) {
          setDatagridData(dataGridData.filter((row) => row.id !== id));
        }
      };

    // When user search for product data based on search pannle
    const handleSearchProduct = async () => {
      try{
      dispatch(requestShowLoader())
          const queryparams = {
            params: {
              ...productSearch,
              vendorId : productSearch?.selectedVendor?.id
            }
          }
        dispatch(requestGetAllProducts(queryparams));
      }
        catch{

        }
        finally{
          dispatch(requestHideLoader())
        }
    }
    

    const handleUpdateProduct = async (rowRecord) => {


    const Id = rowRecord?.id;

    const { id, updated, ...UpdatedproductData} = rowRecord;
    
    const payload = {
        ...UpdatedproductData,
        price: parseInt(UpdatedproductData?.price),
        hotnessQuotient: parseInt(UpdatedproductData?.hotnessQuotient)
    }
try {
    await updateRequestData(payload, `products/${Id}`);

        enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_UPDATED_SUCCESSFULLY"), {variant: 'success'});

    handleSearchProduct();
} catch (error) {
        enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_PLEASE_TRY_AGAIN"), {variant: 'error'});

} finally {
    dispatch(requestHideLoader());
}}

    const handleSave = async() => {
      const reqUrl = `${process.env.REACT_APP_BASE_URL}products/${selectionModel.toString()}`
      const response =  await requestDeleteApiCall(reqUrl);
      if(response?.status == 200) {
              enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_PLEASE_TRY_AGAIN"), {variant: 'success'});
              setDeleteProductDialog(false);
      }
  }
  
  const productSearchBox = {
    ...productSearch
  }
  const handleSelectAutocomplete = (e,value,name)=>{
          dispatch(setSearch(searchEntity?.product, {
              ...productSearch,
              [name] : value,
              vendorId : value?.id
          }));
      }
     const processRowUpdate = (newRow, oldRow) => {
              if(JSON.stringify(newRow) == JSON.stringify(oldRow)) {
                enqueueSnackbar(handleValidateCodevalue(internationalise,'COMMON_NO_DATA_CHANGED'), {variant: 'info'});
              } else {
                handleUpdateProduct(newRow); 
              }
          const updatedRow = { ...newRow, isNew: false };
          setDatagridData(dataGridData.map((row) => (row.id === newRow.id ? updatedRow : row)));
          return updatedRow;
            };

    const isLoadingProgress = useSelector(state => state?.global.isLoading); 
    return(
        <BiztantuLoader isChildren={true} open={isLoadingProgress}>
        <Box className="product-index-container">
        <StyledConfigurationContainer>
              <Typography variant='h6'>
                   {handleValidateCodevalue(internationalise,'PROD_SEARCH_TITLE')}
              </Typography>
              </StyledConfigurationContainer>
          <StyledIndexContainerDiv>
              <StyledLeadContainer className="product-search-panel">
                <Stack className='table-header-search table-header-search-common'>
                  <BiztantuSearch
                  showStatus = {false}
                  entityDetails = {productSearchBox}
                  ownerlistdropdown = {ownerlistdropdown}
                  handleReset = {handleResetSearch}
                  handleSearch = {handleSearchProduct}>
                  <SearchProduct
                  handleSelectAutocomplete = {handleSelectAutocomplete}
                  entityDetails = {productSearch}
                  handleOnChange = {handleChangeSearchField}
                  />
                  </BiztantuSearch>
                </Stack>
                <Stack className='secondry-btn-container' width="60%" padding="10px" justifyContent="flex-end" spacing={2} direction="row">
                  {specificRolePermission?.isProductManage && 
                  <>
                  <Button
                  className='biztantu-sec-btn' variant="outlined" onClick={() => navigateTo(privateRoutesPath.CREATE_PRODUCT)}>{handleValidateCodevalue(internationalise,'PROD_CREATE')}</Button>
                        </>
                      }
                </Stack>
            </StyledLeadContainer>
      
            <DataGridTable 
                isCheckboxReq={false}
                dataGridData={dataGridData}
                gridType="Product"
                height='calc(100vh - 270px)'
                filename="product"
                selectionModel={selectionModel}
                columns={columns}
                rowModesModel={rowModesModel}
                isRequiredToolBar = {specificRolePermission?.isProductManage ? true : false}
                handleUpdateProduct={handleUpdateProduct}
                setSelectionModel={(data) => setSelectionModel(data)}
                processRowUpdate={processRowUpdate}
                handleDeleteProduct={() => setDeleteProductDialog(true)}
            />
            {
                isDeleteProductDialog && (
                    <LeadDialog 
                        open = {isDeleteProductDialog}
                        handleClose = {() => setDeleteProductDialog(false)}
                        handleSave={handleSave}
                        selectedowner={true}
                        title= {handleValidateCodevalue(internationalise,'PRODUCT_DELETE_TITLE')}
                        size="sm"
                        btnlabel= {handleValidateCodevalue(internationalise,'COMMON_YES')}
                        alternateBtnLabel = {handleValidateCodevalue(internationalise,'COMMON_CANCEL')}
                    >
                        <Typography gutterBottom>
                        {handleValidateCodevalue(internationalise,'PRODUCT_DELETE_CONFIRMATION')}
                        </Typography>

                
                    </LeadDialog>
                )
            }
            </StyledIndexContainerDiv>
            </Box>
        </BiztantuLoader>

    )
}

export default ProductPage;